<script>
    import {useNavigate, useParams} from "svelte-navigator";
    import {blogs} from "./blog-store";
    import {getBlogByIdFromFireStore} from "../../config/database-repo";
    import NotFound from "../../components/NotFound.svelte";
    import Spinner from "../../components/ui/Spinner.svelte";

    const navigate = useNavigate();
    const params = useParams();

    let blog;
    $: if (blogs.getBlogsCount() === 0) {
        getBlogByIdFromFireStore($params.id)
            .then(res => {blog = res;})
    } else {
        blog = blogs.findById($params.id);
    }

    function goBack(event) {
        if (event.keyCode === 37 || event.keyCode === 27) {
            navigate(-1)
        }
    }
</script>


<!--------------------------------------------------------------------------------------------------------------------->
<svelte:window on:keydown={goBack} />

{#if blog?.content}
    <article class="blogpost">
        <h1>{blog.title}</h1>

        {#each blog.content as contentItem}
            {#if contentItem.type === 'text'}
                <p>{contentItem.value}</p>
            {:else}
                <figure>
                    <img src="{contentItem.value}" alt={contentItem.desc ? contentItem.desc : 'picture'}>
                    {#if contentItem.desc}<figcaption>{contentItem.desc}</figcaption>{/if}
                </figure>
            {/if}
        {/each}
    </article>
{:else if blog === undefined}
    <Spinner />
{:else}
    <NotFound title="Blog"/>
{/if}


<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .blogpost {
        padding: 0 7px;
        width: 95%;
        margin: 0 auto;
    }
    h1 {
        padding-bottom: 30px;
    }

    p {
        padding: 0 2px 30px;
        text-align: justify;
        font-size: 1.2rem;
    }

    figure {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
        margin-top: 10px;
    }
    img {
        max-width: 100%;
        height: auto;
        max-height: 90vh;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }
    figcaption {
        font-size: .9rem;
        font-style: italic;
        margin: 4px 3px 0;
        align-self: flex-start;
    }

    /*==================================     MEDIA     ======================================*/
    @media screen and (max-width: 500px) {
        .blogpost {
            width: 100%;
            padding: 0 4px;
        }
        img {
            border-radius: 5px;
        }
    }
</style>
